<template>
  <div class="sidebar">
    <v-runtime-template :template="template" />
    <b-modal :id="idModalConfirmDelQuestion" hide-header hide-footer>
      <div class="modal-confirm border-rd-10 text-center">
        <p>Bạn chắc chắn muốn làm lại tất cả bài tập?</p>
        <div class="modal-confirm__action text-center">
          <b-button variant="danger" class="font-size-16 line-height-1"
            @click="$bvModal.hide(idModalConfirmDelQuestion)">Hủy</b-button>
          <b-button variant="success" class="font-size-16 line-height-1" @click="resetQuestionsList()">Làm lại
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

import VRuntimeTemplate from "v-runtime-template";
import { mapState, mapActions } from "vuex"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY, TYPE_EXERCISE_THEMATIC, TYPE_EXERCISE_OTHER, LOCAL_SAVE_CURRENT_THEMATIC } from "./../../_store/constants"
import { getCatOfExerciseOtherOrThematic } from './../../_api/'
import mixinExercise from './../../_store/mixinExercise'
import DropdownCat from './../DropdownCat.vue'
import { getAuth } from '@/utils/jwt'
export default {
  name: 'ThematicSidebar',
  mixins: [mixinExercise],
  components: {
    VRuntimeTemplate,
    vueCustomScrollbar,
    DropdownCat
  },
  data: () => ({
    template: "",
    settingsViewBookSidebar: {
      maxScrollbarLength: 300
    },
    dataCatsThematic: [],
    idsCatActive: [],
    idModalConfirmDelQuestion: 'modal_confirm_reset',
    authInfo: {}
  }),
  computed: {
    routerParams() {
      return this.$route.params
    },
    classId() {
      return parseInt(this.$route.params.classId);
    },
    subjectId() {
      return parseInt(this.$route.params.subjectId);
    },
    chapterId() {
      return parseInt(this.$route.params.id);
    },
    typeId() {
      return this.$route.name === 'exerciseOtherDetail' ? TYPE_EXERCISE_OTHER : TYPE_EXERCISE_THEMATIC
    },
    screenWidth() {
      return window.innerWidth;
    },
    ...mapState(STORE_KEY, ['paramsFilterExOtherThematic'])
  },
  mounted() {
    this.getCatsOfThematic();
  },
  created(){
    this.authInfo = getAuth();
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions('auth', ['setToggleLoginForm']),
    ...mapActions(STORE_KEY, ['acSetParamFilterOtherThematic', 'acSetCatsFlat']),

    getCatsOfThematic() {
      this.setLoading(true)
      let paramsFilter = { classId: this.classId, subjectId: this.subjectId, type: this.typeId }
      if (!this.paramsFilterExOtherThematic.type || this.paramsFilterExOtherThematic.type === 0) {
        this.acSetParamFilterOtherThematic({ ...paramsFilter })
      }

      getCatOfExerciseOtherOrThematic(paramsFilter).then(async res => {
        if (res && res.data && !res.errors) {
          this.dataCatsThematic = await this.flatenCatsExOtherOrThematic(res.data)
          if (this.chapterId === 0 && this.dataCatsThematic) {
            let catActive = this.dataCatsThematic[0].chapterId
            this.getDetailThematicOrQuestionOther({ collapseId: `cat_1_${catActive}`, chapterId: catActive, hasChild: this.dataCatsThematic[0].listChapterChild && this.dataCatsThematic[0].listChapterChild.length > 0, childIndex: 1 }, false)
          }
          this.acSetCatsFlat(this.dataCatsThematic)
          // Set cat active
          await this.getCatActive()
          this.template = `<vue-custom-scrollbar id="book_viewer__cats" class="scroll-area scroll-area__cats scroll-area__cats__exercise">
                              <div class="book-viewer__cats__wrap">`
          this.convertCatsData(res.data)
          this.template += `</div></vue-custom-scrollbar>`
        }
      }).finally(() => this.setLoading(false))

    },

    async convertCatsData(data, parent = null, isChild = false, childIndex = 0) {
      let self = this;
      if (isChild) {
        self.template += `<b-collapse id="cat_${childIndex}_${parent.chapterId}" :visible="${parent && parent.chapterId && self.idsCatActive && self.idsCatActive.includes(parent.chapterId)}" accordion="my-accordion-${childIndex}" role="tabpanelchild"><b-card-body>`
      }
      if (data && data.length > 0) {
        self.template += `<ul class="margin-0 p-0">`
        let lengthData = data.length
        await data.map(async (cat, index) => {
          // class="${self.collapseOpen === 'cat_' + cat.chapterId ? 'active' : ''}"
          // class="${self.idsCatActive && self.idsCatActive.length > 0 && self.idsCatActive.includes(cat.chapterId) ? 'active' : ''}"
          // class="${self.$route.params.id === cat.chapterId ? 'active' : ''}"
          self.template += `<li :class="{'active': parseInt($route.params.id) === ${cat.chapterId} || chapterId === ${cat.chapterId}}">
                                <a
                                  href="javascript:;"
                                  style="color: #0f3dba !important"
                                  class="display-flex display-flex-center justify-content-between"
                                  v-b-toggle.cat_${childIndex + 1}_${cat.chapterId}
                                  id='cat_thematic_${cat.chapterId}'
                                  data-idchild='cat_${childIndex + 1}_${cat.chapterId}'
                                  @click="getDetailThematicOrQuestionOther({collapseId: 'cat_${childIndex + 1}_${cat.chapterId}', chapterId: ${cat.chapterId}, hasChild: ${cat.listChapterChild && cat.listChapterChild.length > 0}, childIndex: ${childIndex + 1}},true)"
                                >
                                  <span>${cat.title}</span>
                                  <DropdownCat v-if="${cat.chapterId} === parseInt($route.params.id)" :dataSource="{id: ${cat.chapterId}, title: '${cat.title}'}" :type="${TYPE_EXERCISE_OTHER}" @resetQuestions="$bvModal.show(idModalConfirmDelQuestion)" />
                                </a>`
          if (cat.listChapterChild && cat.listChapterChild.length > 0) {
            self.convertCatsData(cat.listChapterChild, cat, true, childIndex + 1)
          }
          self.template += `</li>`
          if (index === lengthData - 1) {
            self.template += `</ul>`
          }
          if (isChild && index === lengthData - 1) {
            self.template += `</b-card-body></b-collapse>`
          }
        })
      }
    },
    changeChapter(targetCat,catsFlatForExercise,type,indexCatCurr){
      console.log(targetCat)
      if(type == 1){
          while(targetCat.listChapterChild.length>0){
            let el = document.getElementById(`cat_thematic_${targetCat.chapterId}`)
            let idListChild = el.dataset.idchild
            let elchild = document.getElementById(idListChild)
            if(!elchild.classList.contains('show')){
                document.getElementById(`cat_thematic_${targetCat.chapterId}`).click()
            }
            if(type == 1){
              indexCatCurr++
            }
            else{
              indexCatCurr--
            }
             targetCat = type === 0 ? catsFlatForExercise[indexCatCurr - 1] : catsFlatForExercise[indexCatCurr + 1]
          }
        }
        else{
          while(targetCat.listChapterChild.length>0){
            if(type == 1){
              indexCatCurr++
            }
            else{
              indexCatCurr--
            }
            if(indexCatCurr - 1 < 0){
              return null
            }
            targetCat = type === 0 ? catsFlatForExercise[indexCatCurr - 1] : catsFlatForExercise[indexCatCurr + 1];
          }
          let itemParent = targetCat
          let listParent = []
          while(itemParent.parentId){
            for(let i=0;i<catsFlatForExercise.length;i++){
              let item = catsFlatForExercise[i]
              if(item.chapterId == itemParent.parentId){
                itemParent = item
                break
              }
            }
            listParent.push(itemParent)
          }
          listParent.reverse();
          for(let i = 0; i<listParent.length;i++){
            let item = listParent[i]
            let el = document.getElementById(`cat_thematic_${item.chapterId}`)
            let idListChild = el.dataset.idchild
            let elchild = document.getElementById(idListChild)
            if(!elchild.classList.contains('show')){
                document.getElementById(`cat_thematic_${item.chapterId}`).click()
            }
          }
        }
      return targetCat;
    },
    setCurrentThematic() {
      let dataCurrentThematic = localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC) ? JSON.parse(localStorage.getItem(LOCAL_SAVE_CURRENT_THEMATIC)) : []
      if (dataCurrentThematic.length === 0) {
        dataCurrentThematic.push({ email: this.authInfo.email, classId: this.classId, subjectId: this.subjectId, typeId: this.typeId, chapterId: this.chapterId })
      }
      else {
        let isUpdate = false
        for (let i = 0; i < dataCurrentThematic.length; i++) {
          if (dataCurrentThematic[i].email == this.authInfo.email && dataCurrentThematic[i].classId === this.classId && dataCurrentThematic[i].subjectId === this.subjectId && dataCurrentThematic[i].typeId === this.typeId) {
            dataCurrentThematic[i].chapterId = this.chapterId
            isUpdate = true
            break
          }
        }
        if (!isUpdate) {
          dataCurrentThematic.push({ email: this.authInfo.email, classId: this.classId, subjectId: this.subjectId, typeId: this.typeId, chapterId: this.chapterId })
        }
      }
      localStorage.setItem(LOCAL_SAVE_CURRENT_THEMATIC, JSON.stringify(dataCurrentThematic))
    },
    getDetailThematicOrQuestionOther(cat = null, isSetChaper) {
      let nameRouter = this.typeId === TYPE_EXERCISE_THEMATIC ? 'exerciseThematicDetail' : 'exerciseOtherDetail'
      let queryParams = this.typeId === TYPE_EXERCISE_THEMATIC ? { cauhoi: 0 } : { cauhoi: 1 }
      this.chapterId !== cat.chapterId && this.$router.replace({ name: nameRouter, params: { ...this.routerParams, id: cat.chapterId }, query: queryParams })
      if(isSetChaper){
        this.setCurrentThematic()
      }
      this.typeId === TYPE_EXERCISE_THEMATIC && parseInt(this.$route.query.cauhoi) !== 0 && this.$router.replace({query: queryParams})      
    },

    getCatActive() {
      this.idsCatActive = []
      let indexCatActive = this.dataCatsThematic ? this.dataCatsThematic.findIndex(cat => cat.chapterId === this.chapterId) : -1
      if (indexCatActive > -1) {
        let chapterIdCurr = this.dataCatsThematic[indexCatActive].chapterId
        let catActive = this.dataCatsThematic[indexCatActive].parents
        let catActiveLength = catActive.length

        this.idsCatActive.push(this.dataCatsThematic[indexCatActive].chapterId)
        if (catActiveLength > 0) {
          catActive.map((cat, index) => {
            this.idsCatActive.push(cat.chapterId)
          })
        }
      }
    },

    resetQuestionsList() {
      this.$emit('resetQuestions', true)
      this.$bvModal.hide(this.idModalConfirmDelQuestion)
    }
  }
};
</script>
<style lang="scss" scoped>
.book-viewer__cats__title {
  margin-bottom: 20px;
}

.modal-confirm {
  padding: 20px 15px;

  p {
    margin-bottom: 15px;
  }

  &__action {
    >* {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
</style>